import AboutLeftTab from './AboutLeftTab';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';

const AcademicCouncil = () => {
  return (
    <>
      <Navbar />
      <div className="graduate-admission pt-lg-5 pt-4 pb-70">
        <div className="container">
          <div className="row">
            <AboutLeftTab />
            <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
              <div className="how-to-apply">
                <h2>
                  Academic Council
                </h2>
                <div className="detgails-right-content mt-4">
                  <div className="related-download bg-gray">
                    <ul>
                      <li>
                        <a href="https://admin.swec.ac.in/assetsswec/documents/academic-council/fourth-academic-council-minutes.pdf" target="_blank">
                          <i className="fa-solid fa-file-pdf"></i> 2024–25 – Fourth Academic Council Minutes
                        </a>
                      </li>
                      <li>
                        <a href="https://admin.swec.ac.in/assetsswec/documents/academic-council/third-academic-council-minutes.pdf" target="_blank">
                          <i className="fa-solid fa-file-pdf"></i> 2023–24 – Third Academic Council Minutes
                        </a>
                      </li>
                      <li>
                        <a href="https://admin.swec.ac.in/assetsswec/documents/academic-council/second-academic-council-minutes.pdf" target="_blank">
                          <i className="fa-solid fa-file-pdf"></i> 2022–23 – Second Academic Council Minutes
                        </a>
                      </li>
                      <li>
                        <a href="https://admin.swec.ac.in/assetsswec/documents/academic-council/first-academic-council-minutes.pdf" target="_blank">
                          <i className="fa-solid fa-file-pdf"></i> 2021–22 – First Academic Council Minutes
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>



              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AcademicCouncil